export default {
    CREATE_OET_IN: "[zina_flow][oet] create oet india",
    CREATE_OET_IN_SUCCESS: "[zina_flow][oet] create oet india success success",
    CREATE_OET_IN_FAIL: "[zina_flow][oet] create oet india fail",

    GET_OET_IN_DETAIL: "[zina_flow][oet] get oet india detail",
    GET_OET_IN_DETAIL_SUCCESS: "[zina_flow][oet] get oet india detail success",
    GET_OET_IN_DETAIL_FAIL: "[zina_flow][oet] get oet india detail fail",

    GET_SITES: "[zina_flow][oet] get sites oet",
    GET_SITES_SUCCESS: "[zina_flow][oet] get sites oet success",
    GET_SITES_FAIL: "[zina_flow][oet] get sites oet fail",
    SITES_CHANGE_PAGE: "[zina_flow][oet] sites Change page",
    SITES_UPDATE_PAGINATION: "[zina_flow][oet] sites Update pagination",

    GET_SSOTITEM: "[zina_flow][oet] get SiteServiceOrderTemplateItem",
    GET_SSOTITEM_SUCCESS: "[zina_flow][oet] get SiteServiceOrderTemplateItem success",
    GET_SSOTITEM_FAIL: "[zina_flow][oet] get SiteServiceOrderTemplateItem fail",
    SSOTITEM_CHANGE_PAGE: "[zina_flow][oet] ssot Change page",
    SSOTITEM_UPDATE_PAGINATION: "[zina_flow][oet] ssot Update pagination",

    EXECUTE_SERVICE: "[zina_flow] Execute service",
    EXECUTE_SERVICE_SUCCESS: "[zina_flow] Execute service success",
    EXECUTE_SERVICE_FAIL: "[zina_flow] Execute service failed",
    // RUNs
    GET_RUN_LIST: "[zina_flow][oet] get run list",
    GET_RUN_LIST_SUCCESS: "[zina_flow][oet] get run list success",
    GET_RUN_LIST_FAIL: "[zina_flow][oet] get run list fail",

    GET_RUN_DETAIL: "[zina_flow][oet] get run detail",
    GET_RUN_DETAIL_SUCCESS: "[zina_flow][oet] get run detail success",
    GET_RUN_DETAIL_FAIL: "[zina_flow][oet] get run detail fail",

    CREATE_RUN: "[zina_flow][oet] create run",
    CREATE_RUN_SUCCESS: "[zina_flow][oet] create run success",
    CREATE_RUN_FAIL: "[zina_flow][oet] create run fail",

    UPDATE_RUN: "[zina_flow][oet] update run",
    UPDATE_RUN_SUCCESS: "[zina_flow][oet] update run success",
    UPDATE_RUN_FAIL: "[zina_flow][oet] update run fail",

    SYNCQUANTITYCONTRACT: "[zina_flow][oet] sync quantity contract",
    SYNCQUANTITYCONTRACT_SUCCESS: "[zina_flow][oet] sync quantity contract success",
    SYNCQUANTITYCONTRACT_FAIL: "[zina_flow][oet] sync quantity contract fail",
    
    CHANGE_QUANTITY_LIMIT: "[zina_flow][oet] change quantity limit",
    CHANGE_QUANTITY_LIMIT_SUCCESS: "[zina_flow][oet] change quantity limit success",
    CHANGE_QUANTITY_LIMIT_FAIL: "[zina_flow][oet] change quantity limit fail",

    SYNCWBS: "[zina_flow][oet] sync WBS",
    SYNCWBS_SUCCESS: "[zina_flow][oet] sync WBS success",
    SYNCWBS_FAIL: "[zina_flow][oet] sync WBS fail",

    SYNCVOA: "[zina_flow][oet] sync VOA",
    SYNCVOA_SUCCESS: "[zina_flow][oet] sync VOA success",
    SYNCVOA_FAIL: "[zina_flow][oet] sync WBS fail",

    GET_SSOTI_ONLY_PARENT: "[zina_flow][oet] get SSOTI only parent",
    GET_SSOTI_ONLY_PARENT_FAIL: "[zina_flow][oet] get SSOTI only parent fail",
    GET_SSOTI_ONLY_PARENT_SUCCESS: "[zina_flow][oet] get SSOTI only parent success",

    // REST ACTIONS
    CANCEL_SSOT_ITEMS: "[zina_flow][oet] cancel SSOT Items",
    CANCEL_SSOT_ITEMS_SUCCESS: "[zina_flow][oet] cancel SSOT Items success",
    CANCEL_SSOT_ITEMS_FAIL: "[zina_flow][oet] cancel SSOT Items fail",

    // RP Validation
    START_PR_VALIDATION: "[zina_flow][pr_validation] start pr validation",
    START_PR_VALIDATION_SUCCESS: "[zina_flow][pr_validation] start pr validation success",
    START_PR_VALIDATION_FAIL: "[zina_flow][pr_validation] start pr validation fail"
};
